(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fabric-calculator"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    // Trigger öffnet zugehöriges Modal
    var trigger = e.target.closest('.ws-fabric-calc__trigger');
    if (trigger) {
      var modal = document.getElementById(trigger.dataset.wsOpen);
      if (modal && typeof modal.showModal === 'function') modal.showModal();
      return;
    }

    // Tab-Wechsel innerhalb eines Modals
    var tab = e.target.closest('.ws-fabric-calc__tab');
    if (tab) {
      var modalEl = tab.closest('.ws-fabric-calc__modal');
      if (!modalEl) return;
      modalEl.querySelectorAll('.ws-fabric-calc__tab').forEach(function (t) { t.classList.remove('is-active'); });
      modalEl.querySelectorAll('.ws-fabric-calc__panel').forEach(function (p) { p.classList.remove('is-active'); });
      tab.classList.add('is-active');
      var target = document.getElementById(tab.dataset.target);
      if (target) target.classList.add('is-active');
      return;
    }

    // Klick auf Backdrop schließt das Modal
    if (e.target.classList && e.target.classList.contains('ws-fabric-calc__modal')) {
      e.target.close();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
